export const checkAllSlotsEmpty = (slots) => {
    if(slots){
        let flag=true;
        for(let i=0; i<Object.keys(slots).length; i++){
            let slot = Object.keys(slots)[i];
            if(slots[slot].length !== 0) {
                flag=false
            };
        }
        return flag;
    }
    return false;
}